<!--
* @Description:相关调研5
* @Date: 2024-01-22 12:21:01
-->
<template>
  <div
    class="patient-sex"
    ref="TaskRef"
    :style="{
      transform: `scale(${scale})`,
      transformOrigin: '0 0'
    }"
  >
    <div class="contnet" ref="ContentRef">
      <div class="contnet-warp">
        <div class="content-warp-round-bg">
          <div class="content-warp-round-bg-r">
            <div class="content-warp-round-bg-left"></div>
            <div class="content-warp-round-bg-right"></div>
          </div>
        </div>
        <div class="content-warp-round-tip">
          <div
            class="content-warp-round-tip-item"
            :class="{ 'justify-contents': splitCount < 3 }"
            v-for="(item, index) in data['tipData']"
            :key="index"
            :style="{
              '--location': index == 0 ? '-7.5px' : '180.5px'
            }"
          >
            <div
              class="text"
              ref="RefTextItem"
              v-for="(text, index) in item"
              :key="index"
              :style="{
                '--color': `var(--theme-color-${text[text.length - 1]},#000)`
              }"
            >
              <div class="text-item">
                <div class="text-numbder">
                  <!-- {{ sequence[text[text.length - 1] - 1] }} -->
                </div>
                <div class="text-item-bg"></div>
                <div class="text-item-inner">
                  <div>
                    <div
                      v-for="(citem, cindex) in text.slice(0, text.length - 1)"
                      :key="cindex"
                    >
                      {{ citem.label }}：{{ citem.value }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-warp-round-icon">
          <div class="content-warp-round-icon-warp" ref="RefIcon">
            <baseSvg></baseSvg>
          </div>
          <div class="line" v-html="svgHTML"></div>
        </div>
      </div>

      <!-- 项目名称 -->

      <div class="content-name">
        <div>
          <div
            :style="{ '--color': `var(--theme-color-${index + 1},#000)` }"
            v-for="(item, index) in data.projectName"
            :key="index"
          >
            <div class="block-color"></div>
            <!-- <div>{{ sequence[index] }}</div> -->
            <div>{{ item.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue';
import { baseSvg } from './svg-components/index';
import {
  pcModulePatientSex5,
  selfAdaption,
  useDataAssembly
  // sequence
} from './hooks';
const props = defineProps<{
  tableHeaderList: Array<{ label: Array<string>; prop: string }>;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();
const svgHTML = ref('');
let data = useDataAssembly(props.tableHeaderList, props.tableDataList, true);
const splitCount = computed(() => {
  return Math.ceil(data.value.tipData.flat(1).length / 2);
});
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
const RefIcon = ref<HTMLDivElement>();
const RefTextItem = ref<Array<HTMLDivElement>>();
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
  pcModulePatientSex5(RefIcon, RefTextItem, splitCount, svgHTML);
});
</script>

<style lang="scss" scoped>
@import './index.scss';
.patient-sex {
  @include patientSex();
  .contnet {
    @include content();
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .contnet-warp {
      width: 921.32px;
      height: 478.61px;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .content-warp-round-bg {
        width: 921.32px;
        height: 478.61px;
        position: absolute;
        .content-warp-round-bg-r {
          width: 100%;
          height: 100%;
          .content-warp-round-bg-left {
            opacity: 0.2;
            position: absolute;
            left: 0;
            width: 478.61px;
            height: 478.61px;
            border-radius: 100%;
            background-image: linear-gradient(
              -90deg,
              var(--theme-color-1, #000) 20%,
              #fff 100%,
              #fff 100%,
              transparent 100%
            );
          }
          .content-warp-round-bg-right {
            opacity: 0.2;
            position: absolute;
            width: 478.61px;
            height: 478.61px;
            border-radius: 100%;
            right: 0;
            background-image: linear-gradient(
              90deg,
              var(--theme-color-1, #000) 20%,
              #fff 100%,
              #fff 100%,
              transparent 100%
            );
          }
        }
      }
      .content-warp-round-tip {
        position: absolute;
        width: 805.32px;
        height: 401px;
        display: flex;
        justify-content: space-between;
        .content-warp-round-tip-item {
          width: 189.66px;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          &.justify-contents {
            justify-content: center;
          }
          .text {
            margin: 12px 0;
            width: 189.66px;
            height: 117px;
            border-radius: 12px;

            .text-item {
              width: 100%;
              height: 100%;
              position: relative;
              .text-numbder {
                z-index: 10;
                position: absolute;
                width: 15px;
                height: 15px;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: var(--color);
                border-radius: 100%;
                font-size: 22px;
                font-weight: 600;
                color: #ffffff;
                top: 50%;
                transform: translateY(-50%);
                right: var(--location);
              }
              .text-item-bg {
                opacity: $--opacityText;
                position: absolute;
                height: 100%;
                width: 100%;
                border-radius: 12px;
                background-color: var(--color);
              }
              .text-item-inner {
                position: absolute;
                height: 100%;
                width: 100%;
                border-radius: 12px;
                border: 1px solid var(--color);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                > div {
                  @include text();
                }
              }
            }
          }
        }
      }
      .content-warp-round-icon {
        position: absolute;
        width: 805.32px;
        height: 401px;
        display: flex;
        justify-content: center;
        align-items: center;
        .content-warp-round-icon-warp {
          width: 203px;
          height: 73.5px;
          background-color: var(--theme-color-1, #000);
          border-radius: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .line {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    }
    .content-name {
      margin-top: 50px;
      height: 100px;
      width: 100%;
      display: flex;
      justify-content: center;
      > div {
        display: flex;
        width: 80%;
        justify-content: center;

        > div {
          margin: 0 10px;
          display: flex;
          width: 100%;
          > div:nth-child(1) {
            margin-right: 5px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 600;
            color: #0f0f0f;
          }
          > div:nth-child(2) {
            @include bottomText();
          }
        }
      }
    }
  }
}
</style>
